module.exports = __webpack_public_path__ + "static/img/popular-01.5c9fb40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular-01.jpg
// module id = OaFB
// module chunks = 1